import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=7dca61c7"
import script from "./OrderTable.vue?vue&type=script&lang=js"
export * from "./OrderTable.vue?vue&type=script&lang=js"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=7dca61c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports